module.exports = __webpack_public_path__ + "media/people.32382031.mp3";